export default __webpack_public_path__ + "static/media/plain-sticker-V.df20662c.png";